export default __webpack_public_path__ + "static/media/r_wdt_c_1.8c117b67.mp3";